import { Routes, Route } from 'react-router-dom';
import { Home } from '../pages/Home';
import { Nosotros } from '../pages/Nosotros';
import { Busquedas } from '../pages/Busquedas';
import { University } from '../pages/University';

export const Main = () => {
  return (
    <Routes>
      <Route index path='/' element={<Home/>}></Route>
      <Route path='/nosotros' element={<Nosotros/>}></Route>
      <Route path='/busquedas' element={<Busquedas/>}></Route>
      <Route path='/university' element={<University/>}></Route>
    </Routes>
  )
}